import React, { Fragment } from "react";
import styled from "styled-components";
import cx from "classnames";
import TotalBet from "../TotalBet";
// lib
import { createSymbol } from "../../../config/replace";
import { useSelector } from "react-redux";
import { getData } from "common-lib/lib";
// config
import { currencyList } from "../../../config/currencyList";

export const PayTableWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const PayList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  text-align: left;
  flex-wrap: wrap;
  margin-bottom: 60px;
  & .half {
    width: 100%;
    margin: 0 2%;
    display: flex;
    flex-direction: row;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${(props) => (props.isLongList ? "40px" : "-5px")};
    flex: 1;
    @media (min-width: 700px) {
      width: 50%;
    }
    @media (min-width: 1024px) {
    }
    & .pic {
      /* width: 40%;   */
      padding: 20px 0;
      text-align: right;
      .pay-img {
        width: 130px;
        height: 130px;
        image-rendering: -webkit-optimize-contrast;
      }
    }
    & .list {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 24px;
      margin-left: 10px;
      & > div {
        margin: 3px 0;
        white-space: nowrap;
      }
      & span {
        font-size: 24px;
        color: #fff;
        /* margin-left: 5px; */
      }
    }
  }
`;
const Normal = ({
  lang,
  windowDimensions,
  payTableData,
  gameId,
  isCurrency,
  currency,
  denom,
  betLevel,
  moneyConvert,
  symbol,
  bet,
  isLongList,
}) => {
  const imgsdomain = useSelector((state) => state.props.imgsdomain);
  const matchData = [
      {
          "SymbolName": "1",
          "SymbolPays": [
              '2X',
          ]
      },
      {
          "SymbolName": "2",
          "SymbolPays": [
              '2X',
          ]
      },
      {
          "SymbolName": "3",
          "SymbolPays": [
              '3X',
          ]
      },
      {
          "SymbolName": "4",
          "SymbolPays": [
              '4X',
          ]
      },
      {
          "SymbolName": "5",
          "SymbolPays": [
              '5X',
          ]
      },
      {
          "SymbolName": "6",
          "SymbolPays": [
              '6X',
          ]
      },
      {
          "SymbolName": "7",
          "SymbolPays": [
              '7X',
          ]
      },
      {
          "SymbolName": "8",
          "SymbolPays": [
              '8X',
          ]
      },
      {
          "SymbolName": "9",
          "SymbolPays": [
              '9X',
          ]
      },
      {
          "SymbolName": "10",
          "SymbolPays": [
              '10X',
          ]
      },
      {
          "SymbolName": "11",
          "SymbolPays": [
              '12X',
          ]
      },
      {
          "SymbolName": "12",
          "SymbolPays": [
              '15X',
          ]
      },
      {
          "SymbolName": "13",
          "SymbolPays": [
              '18X',
          ]
      },
      {
          "SymbolName": "14",
          "SymbolPays": [
              '20X',
          ]
      },
      {
          "SymbolName": "15",
          "SymbolPays": [
              '25X',
          ]
      },
      {
          "SymbolName": "16",
          "SymbolPays": [
              '30X',
          ]
      },
      {
          "SymbolName": "17",
          "SymbolPays": [
              '40X',
          ]
      },
      {
          "SymbolName": "18",
          "SymbolPays": [
              '50X',
          ]
      },
      {
          "SymbolName": "19",
          "SymbolPays": [
              "80X",
          ]
      },
      {
          "SymbolName": "20",
          "SymbolPays": [
            '100X',
          ]
      },
      {
          "SymbolName": "21",
          "SymbolPays": [
            '25X-75X',
          ]
      },
      {
          "SymbolName": "22",
          "SymbolPays": [
            '25X-75X',
          ]
      },
      {
          "SymbolName": "23",
          "SymbolPays": [
            '1X+N',
          ]
      },
      {
          "SymbolName": "24",
          "SymbolPays": [
            '3X-300X',
          ]
      },
      {
          "SymbolName": "25",
          "SymbolPays": [
            '10X-100X',
          ]
      },
      {
          "SymbolName": "26",
          "SymbolPays": [
            '50X-500X',
          ]
      },
      {
          "SymbolName": "27",
          "SymbolPays": [
            '75X-1000X',
          ]
      }
  ]
  return (
    <PayTableWrapper>
      <TotalBet
        lang={lang}
        isCurrency={isCurrency}
        currency={currency}
        bet={bet}
        denom={denom}
      />
      {/* <p className="title">{translation["payTable"][lang]}</p> */}
      <PayList windowDimensions={windowDimensions} isLongList={isLongList}>
        {matchData.length === 0 ? (
          <div className="half">No PayTable Data</div>
        ) : (
          matchData
            .filter(
              (i) =>
                !getData(i, ["SymbolPays"]).every((v) => v === 0) &&
                getData(i, ["SymbolName"]) !== "SC" &&
                getData(i, ["SymbolName"]) !== "W" &&
                getData(i, ["SymbolName"]) !== "F" &&
                getData(i, ["SymbolName"]) !== "W1" &&
                getData(i, ["SymbolName"]) !== "W2" &&
                getData(i, ["SymbolName"]) !== "W3" &&
                getData(i, ["SymbolName"]) !== "W4" &&
                getData(i, ["SymbolName"]) !== "W5"
            )
            .map((v) => {
              const reverseData = []
                .concat(getData(v, ["SymbolPays"]))
                .reverse();
              return (
                <div className="half" key={getData(v, ["SymbolID"])}>
                  <div className="pic">
                    <img
                      className={cx("pay-img object-fit-scale", {
                        bigSymbol: symbol.some(
                          (i) => i === getData(v, ["SymbolName"])
                        ),
                        mobileSize: windowDimensions.width < 375,
                      })}
                      alt=""
                      src={`${imgsdomain}/vp_project/common/${gameId}/symbolList/fishList/${getData(
                        v,
                        ["SymbolName"]
                      )}.png`}
                    />
                  </div>
                  <div className="list">
                    {reverseData.map(
                      (v, k, array = getData(v, ["SymbolPays"])) => (
                        <Fragment key={k}>
                          {v !== 0 && (
                            <div key={k}>
                              {/* {array.length - k} */}
                              <span className={cx({ money: isCurrency })}>
                                {isCurrency && (
                                  <div
                                    className="symbol"
                                    dangerouslySetInnerHTML={createSymbol(
                                      currencyList[currency]["symbol"],
                                      imgsdomain
                                    )}
                                  />
                                  
                                )}
                                {v}
                              </span>
                            </div>
                          )}
                        </Fragment>
                      )
                    )}
                  </div>
                </div>
              );
            })
        )}
      </PayList>
    </PayTableWrapper>
  );
};

export default Normal;
